import { resetQuestionnaire, setCachedQueryAnswer, setQuestionnaire } from '@/store';
export function handleQbReset(questCtx, message) {
    questCtx.dispatch(resetQuestionnaire());
    const payload = {
        partialSubmission: null,
        questionnaire: JSON.parse(message.data)
    };
    questCtx.dispatch(setQuestionnaire(payload));
}
export function addQbMocks(questCtx, message) {
    var _a, _b;
    if ((_a = message.mocks) === null || _a === void 0 ? void 0 : _a.cachedQuery) {
        questCtx.dispatch(setCachedQueryAnswer((_b = message.mocks) === null || _b === void 0 ? void 0 : _b.cachedQuery));
    }
}
